<!-- 搜索列表 -->
<template>
  <div>
    <van-nav-bar
        title="搜索"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />
    <div class="head">
      <div class="search">
        <van-search v-model="form.keyword" class="search-input" placeholder="请输入影片/影院关键词搜索" />
      </div>
    </div>
    <div>
      <van-list
              v-model="loadingCinema"
              finished=false
              @load="getCinemaList"
      >
        <div class="head title" v-if="cinemaList.length > 0 ">影院</div>
      <div v-for="(item,index) in cinemaList" :key="item.cinemaid"   v-if="index < 3" class="cinema-list" @click="toCinema(item)">
        <div class="title">
          <div class="title-name">{{item.cinemaName || ''}}</div>
          <div class="distance" v-show="item.distance">{{item.distance || ''}}km</div>
        </div>
        <div class="address">{{item.address}}</div>
      </div>

      <van-button class="head" type="info" size="nomal"  @click.stop="toCinemaList()" v-if="cinemaList.length > 3 " >查看全部 {{cinemaTotal}}家 影院列表</van-button>
      </van-list>
    </div>
    <div class="film-list">
      <van-list
              v-model="loadingFilm"
              finished=false
              @load="getFilesList"
      >
        <div class="head title" v-if="filmList1.length > 0 ">影片</div>
      <div v-for="(item,index) in filmList1" :key="item.id" v-if="index < 2"  class="list-item" @click.stop="toFilm(item)">
        <div class="item-image">
          <van-image
                  fit="aspectFill"
                  :src="`${item.poster}_180x180.jpg`"
          >
            <template v-slot:loadingFilm>
            <van-loading type="spinner" size="20" />
            </template>
          </van-image>
        </div>
        <div class="item-content">
          <div class="content-text">
            <div class="film-name">{{item.name}}</div>
            <div>观众评分：<span style="color:#FFAA50">{{item.score || '未评分'}}</span></div>
            <div>导演：{{item.director || '未知'}}</div>
            <div>主演：{{item.leadingRole || '未知'}}</div>
          </div>
          <div class="content-btn">
            <van-button type="info" size="nomal" @click.stop="toBuy(item)" style="width:100%" >特惠购票</van-button>
          </div>
        </div>
      </div>

      <van-button class="head" type="info" size="nomal" @click.stop="toFilmList()" v-if="filmList1.length > 2 " >查看全部 {{filmTotal}}部 影片列表</van-button>
      </van-list>
    </div>
  </div>
</template>

<script>
import {getAllCinemaList, getMovieList} from '@/api/cinema'
export default {
  name: "searchList",
  components: {},
  props: {},
  data() {
    return {
      loadingFilm: false,
      loadingCinema: false,
      loading: false,
      finished: false,  //是否加载
      form: {
        movieId: '',
        city_id: '',
        latitude: '',
        longitude: '',
        keyword: '',
        page: 1,
        page_size: 100
      },
      cinemaList: [],
      filmList: [],
      filmList1: [],
      filmList2: [],
      filmTotal: 0,
      cinemaTotal: 0,
      filmInfo:{
        canbuy:'',
        poster: '',
        name: '',
        grade: '',
        country: '',
        language: '',
        duration: '',
        opentime: '',
        director: '',
        type: '',
        version_types: '',
        description: '',
        actorList: [],
        imgList: [],
        showversionList: {string:[]},
      },
      showAreaList: false, //打开行政区列表
      areaList: [], // 行政区列表
      originalAreaList: [], // 行政区列表（原始数据）
      areaObj: { // 所选行政区
        cityName: '全部',
        cityCode: '',
        id: ''
      }
    }
  },
  methods: {
    // 获取 影片 列表
    getFilesList() {
      this.filmList1 = []
      let form = {}
      form.type = 0
      form.page = this.form.page
      form.page_size = this.form.page_size
      form.keyword = this.form.keyword
      form.city_id = this.cityId
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      this.loadingFilm = true;
      getMovieList(form).then(res=>{
        // console.log('返回结果为：',res);
        if(res?.data?.list?.length){
          let list = res.data.list || [];
          // if(form.type){
          //   // this.filmList2.splice(this.filmList2.length, 0, ...list)
          //   this.filmList2 = list;
          //   // this.$set(this, 'filmList2', this.filmList2);
          //   this.filmTotal = res?.data?.total
          // }else{
          //   // this.filmList1.splice(this.filmList1.length, 0, ...list)
          //   // this.$set(this, 'filmList1', this.filmList1);
          // }
          this.filmList1 = list;
          this.filmTotal = res?.data?.total
          this.finished = list.length < 6;
        }
        // this.form.page ++;
      }).catch(e=>{
        console.log(e)
        if(form.type){
          this.filmList2 = []
        }else{
          this.filmList1 = []
        }
      }).finally(()=>{
        this.loadingFilm = false;
        this.$Toast.clear()
      })
    },
    // 获取影院列表
    getCinemaList() {
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      let form = JSON.parse(JSON.stringify(this.form))
      if(this.areaObj.id){
        // form.areaid = this.areaObj.id //传参
        form.areaid = this.areaObj.cityCode //传参
      }
      if(this.form.keyword){
        form.keyword = this.form.keyword
      }
      form.city_id = this.cityCode
      if(this.cityPosition.latitude){
        form.latitude = this.cityPosition.latitude
        form.longitude = this.cityPosition.longitude
      }
      else{
        form.latitude = this.$route.query.latitude
        form.longitude = this.$route.query.longitude
      }
      this.loadingCinema = true;
      form.city_id = this.cityId;
      getAllCinemaList(form).then(res => {
        this.cinemaList = res?.data?.list || [];
        this.cinemaTotal= res?.data?.total || 0;
        if(res?.data?.list?.length && res.data.list.length < form.page_size){
          this.finished = true
        }else if(!res?.data?.list?.length){
          this.finished = true
        }
      }).catch(e => {
        console.log(e)
        this.finished = true
      }).finally(()=>{
        this.$Toast.clear()
        this.loadingCinema = false
      })
    },
    // 获取行政区列表
    // getAreaList(){
    //   this.$Toast.loading({
    //     message: '加载中...',
    //     forbidClick: true,
    //     duration: 0,
    //   });
    //   this.loading = true
    //   getAllCity({parentId:this.cityId}).then(res => {
    //     let list = res?.data || []
    //     if(list.length){
    //       list.unshift({
    //         cityCode:"",
    //         cityName: '全部',
    //         id: ''
    //       })
    //     }
    //     this.originalAreaList = list
    //     this.areaList = list.map(item=>item.cityName)
    //   }).catch(e => {
    //     console.log(e)
    //     this.areaList = []
    //   }).finally(()=>{
    //     this.$Toast.clear()
    //     this.loading = false
    //   })
    // },
    // // 选择行政区
    // confirmAreaId(e){
    //   this.areaObj = this.originalAreaList[this.areaList.findIndex(item=>item === e)]
    //   this.showAreaList = false
    //   this.getCinemaList()
    // },
    // toLocation(){
    //   this.$router.push({
    //     path:'/location'
    //   })
    // },
    toCinema(item){
      this.$router.push({
        path:'/cinemaDetail',
        query:{
          cinemaid:item.id,
          movieId:this.form.movieId
        }
      })
    },
    toFilm(item){
      this.$router.push({
        path:`/filmDetail`,
        query:{
          movieId:item.movieId
        }
      })
    },
    // 影院列表页
    toCinemaList(){
      if(this.cityPosition.latitude){
        this.form.latitude = this.cityPosition.latitude
        this.form.longitude = this.cityPosition.longitude
      }
      else{
        this.form.latitude = this.$route.query.latitude
        this.form.longitude = this.$route.query.longitude
      }
      this.form.cityName=this.$route.query.cityName
      this.$router.push({
        path:'/cinemaList',
        query:this.form
        // query:{
        //   cinemaid:item.id,
        //   movieId:this.form.movieId
        // }

      })
    },
    // 影片列表页
    toFilmList(){
      if(this.cityPosition.latitude){
        this.form.latitude = this.cityPosition.latitude
        this.form.longitude = this.cityPosition.longitude
      }
      else{
        this.form.latitude = this.$route.query.latitude
        this.form.longitude = this.$route.query.longitude
      }
      this.form.cityName=this.$route.query.cityName
      this.$router.push({
        path:'/filmList',// 不能用首页
        query:this.form
        // query:{
        //   cinemaid:item.id,
        //   movieId:this.form.movieId
        // }
      })
    },
    onClickLeft(){
      this.$route.params.keyword = this.form.keyword;
      this.$route.query.keyword = this.form.keyword;
      this.$router.back()
    },
    toBuy(item){
      this.$router.push({
        path:'/cinemaList',
        query:{
          movieId:item.movieId,
          cityName:this.$store.state.city.cityName,
          latitude:this.$store.state.city.cityPosition.latitude,
          longitude:this.$store.state.city.cityPosition.longitude,
          cityId:this.cityId
        }
      })
    },
  },
  created() {
    this.form.movieId = this.$route.query.movieId;
    this.form.city_id = this.$route.query.cityId;
    this.form.keyword = this.$route.query.keyword ;
    // this.getFilmInfo()
  },
  mounted() {
    // this.getAreaList()
  },
  computed: {
    cityName(){
      let cityId = this.cityId
      if(this.$store.state.city.cityName === null || this.$store.state.city.cityName === ""  ){this.$store.state.city.cityName =  this.$route.query.cityName}
      console.log("query.cityName:", this.$route.query.cityName);
      return this.$store.state.city.cityName
    },
    cityCode(){
      let id = ''
      let cityName = this.$store.state.city.cityName;
      if(this.cityList.length && cityName){
        this.cityList.map(item=>{
          if(item.cityName === cityName){
            id = item.cityCode
          }
        })
      }
      if(id<=0){id = this.$route.query.cityId }
      return id
    },
    cityId(){ //区号
      let id = ''
      let cityName = this.$store.state.city.cityName;
      if(this.cityList.length && cityName){
        this.cityList.map(item=>{
          if(item.cityName === cityName){
            // id = item.id
            id = item.cityCode
          }
        })
      }
      if(id<=0){id = this.$route.query.cityId }
      return id
    },
    cityList(){
      return this.$store.state.cinema.cityList
    },
    cityPosition(){
      return this.$store.state.city.cityPosition
    }
  },
  watch: {
    'form.keyword':{
      handler(){
        this.loading = false
        this.finished = false
        this.cinemaList = []
        if(this.form.keyword){
          this.getFilesList()
          this.getCinemaList()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  background-color: #ffffff;
  position: relative;
  z-index: 0;
  padding-bottom:20px;
}

.header {
  width: 100%;
  height: 372px;
  display: flex;
  position: relative;
  align-items: center;

  .header-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    overflow: hidden;
    -webkit-filter: blur(.3rem) brightness(0.5);
    filter: blur(.3rem) brightness(0.5);
    background-size: cover;
    background-repeat: no-repeat;
    opacity: .55;
    background-position: 0 50% !important;
  }

  .header-img {
    z-index: 100;
    margin-left: 30px;
    align-self: center;
    width:200px;
    height:300px;
    border-radius: 26px;
    overflow: hidden;
  }

  .header-content {
    align-self: center;
    color: #ffffff;
    margin-left: 30px;
    font-size: 24px;

    &>div {
      line-height: 1.7;
    }

    .title {
      font-size: 40px;
      font-weight: bold;
    }
    .score{
      font-size: 30px;
      &>span{
        color: #FFBD00;
        font-weight: bold;
        font-size:46px
      }
    }
  }
}
.head{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size:28px;
  padding:15px 30px;
  .cityName{
    margin-right:15px;
    background-color: #f7f7f7;
    border-radius: 40px;
    padding: 15px 40px;
    .icon{
      margin-right:10px;
    }
  }
  .search{
    flex:1;
    input[class~=van-field__control]{
      font-size:28px!important;
    }
  }
}

.cinema-list {
  padding: 30px;
  font-size: 28px;
  border-bottom: 1px solid #b1b0b0;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-name {
      font-size: 34px;
      font-weight: bold;
    }

    .distance {
      color: #b1b0b0;
    }
  }

  .address {
    margin-top: 20px;
    color: #676767;
  }
}
.list{
  height: calc(100vh - 620px);
  overflow-y: auto;
}

.film-list {
  display: block;
  padding:0 20px;
  .list-item {
    padding: 20px 0;
    border-bottom: 1px solid #F5F5F5;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &:last-child{
      border:none;
    }
    .item-image {
      flex: 0 0 170px;
      margin-right: 20px;
      overflow: hidden;
      border-radius: 26px;
    }

    .item-content {
      flex: 1 1 auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .content-text {
        flex: 1 1 auto;
        width: 330px;
        color: #A1A2A1;
        font-size: 24px;

        .film-name {
          font-size: 32px;
          color: #000000;
        }

        &>div {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 10px 0;
        }

      }

      .content-btn {
        flex: 0 0 170px;
        margin-left: 20px;
      }
    }
  }
}

</style>
